import CnCustomer from "../images/cn/customer2.png"
import cnLogo1 from "../images/cn/logo1.png"
import cnLogo2 from "../images/cn/logo2.png"
import cnLogo3 from "../images/cn/logo3.png"
import cnLogo4 from "../images/cn/logo4.png"
import cnLogo5 from "../images/cn/logo5.png"
import cnLogo6 from "../images/cn/logo6.png"
import cnLogo7 from "../images/cn/logo7.png"
import cnLogo8 from "../images/cn/logo8.png"
import cnLogo9 from "../images/cn/logo9.png"
import cnLogo10 from "../images/cn/logo10.png"
import cnLogo11 from "../images/cn/logo11.png"
import cnLogo13 from "../images/cn/logo13.png"




import { UserLogoMapType, UserLogoMapMobileType } from 'globalCommon/utils/index'

export const UserLogoMap: UserLogoMapType = {
    cn: CnCustomer,



};

/* CN/TW 移动端用横向滚动 logo 列表，EN/EM/JP 仍沿用桌面单图 */
export const UserLogoMapMobile: UserLogoMapMobileType = {
    cn: [cnLogo1, cnLogo2, cnLogo3, cnLogo4, cnLogo9, cnLogo13, cnLogo10, cnLogo11, cnLogo5, cnLogo6, cnLogo7, cnLogo8],

};

/* about-us-cn 专用：全部站点移动端都用滚动 logo 列表（不像 security/enterprise 只有 CN/TW） */
export const UserLogoMapMobileAll: UserLogoMapMobileType = {
    cn: [cnLogo1, cnLogo2, cnLogo3, cnLogo4, cnLogo9, cnLogo13, cnLogo10, cnLogo11, cnLogo5, cnLogo6, cnLogo7, cnLogo8],



};
